import * as actionTypes from '../actionTypes';

/*
 * `loading` starts true so the table shows its preloader before the first page lands, rather than
 * flashing "No activation codes" at someone whose list is still on the wire.
 */
export const INITIAL_STATE = {
	error: null,
	loading: true,
	activationKeys: [],
	pagination: {}
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case actionTypes.START_INCREASE_ACTIVATIONS:
			return {
				...state,
				error: null
			};
		case actionTypes.START_FETCHING_VM_ACTIVATION_CODES:
			return {
				...state,
				loading: true,
				error: null
			};
		case actionTypes.GET_VM_ACTIVATION_CODES_SUCCESS:
			return {
				...state,
				loading: false,
				activationKeys: action.payload.items,
				pagination: action.payload.pagination
			};
		/*
		 * A refused read (no staff login, a page out of range) leaves the table empty, saying
		 * "No activation codes", as the page always has (SYN-3456). The rows of the previous page
		 * would otherwise pass for the answer to the page or the key that was asked for.
		 */
		case actionTypes.GET_VM_ACTIVATION_CODES_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload,
				activationKeys: [],
				pagination: {}
			};
		case actionTypes.INCREASE_ACTIVATIONS_SUCCESS:
			return {
				...state,
				loading: false
			};
		case actionTypes.INCREASE_ACTIVATIONS_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload
			};
		default:
			return state;
	}
};
